import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import {initialsForUser} from "shared/initials"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import {User} from "models"

/**
 * @typedef {object} ComponentsUsersCircleIconProps
 * @property {unknown} className
 * @property {unknown} user
 */

/** @typedef {object} ComponentsUsersCircleIconState */

/**
 * @extends {ShapeComponent<ComponentsUsersCircleIconProps, ComponentsUsersCircleIconState>}
 */
class ComponentsUsersCircleIcon extends ShapeComponent {
  static propTypes = {
    user: PropTypes.instanceOf(User).isRequired
  }

  render() {
    const {className, user, ...restProps} = this.props

    return (
      <div className={classNames("components--users--circle-icon", className)} {...restProps}>
        {initialsForUser(user)}
      </div>
    )
  }
}

export default memo(shapeComponent(ComponentsUsersCircleIcon))
